import { eventBus, EVENTS, EventPayload } from '../store/eventBus';

export const communication = {
  // Emite eventos
  emitReferenceId: (reference_id: string) => {
    eventBus.emit(EVENTS.REFERENCE_ID_UPDATED, { reference_id });
  },
  // Escuta eventos
  onReferenceId: (callback: (reference_id: string) => void) => {
    eventBus.on<EventPayload[typeof EVENTS.REFERENCE_ID_UPDATED]>(EVENTS.REFERENCE_ID_UPDATED, payload =>
      callback(payload.reference_id)
    );
  },
  // Remove listeners
  offReferenceId: (callback: (reference_id: string) => void) => {
    eventBus.off<EventPayload[typeof EVENTS.REFERENCE_ID_UPDATED]>(EVENTS.REFERENCE_ID_UPDATED, payload =>
      callback(payload.reference_id)
    );
  },

  emitClearChat: () => {
    eventBus.emit(EVENTS.CLEAR_CHAT, {});
  },
  onClearChat: (callback: () => void) => {
    eventBus.on<EventPayload[typeof EVENTS.CLEAR_CHAT]>(EVENTS.CLEAR_CHAT, _ =>
      callback()
    );
  },
  offClearChat: (callback: () => void) => {
    eventBus.off<EventPayload[typeof EVENTS.CLEAR_CHAT]>(EVENTS.CLEAR_CHAT, _ =>
      callback()
    );
  },
};
